import moment from 'moment';

const overrideMomentToJson = (momentClass: typeof moment): void => {
	// @ts-ignore
	momentClass.fn.toJSON = function (): string {
		return this.toISOString(true);
	};
};

export default overrideMomentToJson;
